let goodsData = [{
	"id": 1000271,
	"name": "锁闭阀电子锁",
	"name_title": "阀门专用",
	"model": "CG-VL-01",
	"sku_info": [{
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/valve/valve/valve1.jpg'),
		"spec_json": {
			"show_name": "正面"
		}
	}]
}]

export default goodsData


// WEBPACK FOOTER //
// ./src/lib/valvesData.js